<template>
  <v-select
    v-model="$i18n.locale"
    variant="solo"
    density="compact"
    hide-details
    prepend-inner-icon="mdi-web"
    flat
    max-width="145px"
    class="selector"
    data-cy="language-selector"
    :items="languageOptions"
    @update:model-value="changeLanguage($event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { captureLanguage } from '@/util/posthog';
import { i18n } from '@/plugins/i18n';

export const languageOptions = [
  { title: i18n.t('administration.languagesEN'), value: 'en_US' },
  { title: i18n.t('administration.languagesDE'), value: 'de_DE' }
];

export default defineComponent({
  name: 'LanguageSelector',
  data() {
    return {
      languageOptions: languageOptions
    };
  },
  methods: {
    changeLanguage(language: string) {
      localStorage.setItem('currentLang', language);
      captureLanguage();
    }
  }
});
</script>

<style scoped lang="scss">
.selector:deep(.v-input__control > .v-field) {
  font-size: 14px;
}
.selector:deep(.v-icon) {
  color: black;
  padding-right: 5px;
}
.selector .v-field__field .v-field__input {
  height: 30px;
}
</style>
